<!--  -->
<template>
  <div>
    <div id="cont">
      <div class="cont">
        <div class="cont_l">
          <div class="cont_l_01">
            <div class="cont_l_02">
              <img :src="images.sb_03">
            </div>
            <div class="cont_l_03">
              <ul class="lit01">
                <li class="lit01_c">
                  <p class="littitle">{{text.device01}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/deviceen/lglzen">{{text.device02}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceen/ggscen">{{text.device03}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceen/gjscen">{{text.device04}}</router-link>
                    </li>
                  </ul>

                  <p class="littitle">{{text.device05}}</p>

                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/deviceen/gsplen">{{text.device06}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceen/spfren">{{text.device07}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceen/xxzjen">{{text.device08}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceen/dkzjen">{{text.device09}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceen/lhlben">{{text.device10}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceen/jyjjen">{{text.device11}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceen/zsthen">{{text.device12}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceen/lxthen">{{text.device13}}</router-link>
                    </li>
                  </ul>

                  <p class="littitle">{{text.device14}}</p>

                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/deviceen/jcjen">{{text.device15}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceen/jcmjen">{{text.device16}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceen/zsmjen">{{text.device17}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceen/jtlgen">{{text.device18}}</router-link>
                    </li>
                  </ul>

                  <p class="littitle">{{text.device19}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/deviceen/dkzgen">{{text.device20}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceen/lxgpen">{{text.device21}}</router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div class="cont_l_04"></div>
          </div>
        </div>
        <div class="cont_r">
          <div class="cont_r_t">
            <div class="cont_r_t01">
              <span>{{text.profile3}}</span>
              <span>：</span>
              <span>{{text.profile4}}</span>
              <span>-</span>
              <span>{{text.device22}}</span>
            </div>
          </div>
          <div class="cont_r_b">
            <div id="rightdiv">
              <router-view></router-view>
            </div>
            <div class="cont_r_b10">
              <router-link to="/bbsen" target="_blank">
                <img :src="images.scy_03">
              </router-link>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        scy_03: require("../../../assets/img/en/scy_03.jpg"),
        sb_03: require("../../../assets/img/en/sb_03.jpg")
      },
      text: {
        product3: "Aluminum Coil/Aluminum Plate/Aluminum Foil/CanBody",
        product4: "Remelt Lead Ingot/Remelt Zinc Ingot",
        device01: "COMPLETE EQUIPMENTS",
        device02: "Continues casting and rolling production line for",
        device03: "Continues casting and rolling production line for",
        device04: "Finishing production line for Steel Bars",
        device05: "PROCESSING EQUIPMENTS FOR ",
        device06: "High Speed Spinner Block",
        device07: "Level Rewinding Machine",
        device08: "Planetary Rolling Mill",
        device09: "Multi-Rolling Mill",
        device10: "Combined Drawing Machine",
        device11: "Machines Group of Extrusion Press",
        device12: "Bell Type Annealing Furnace",
        device13: "Continues Annealing Furnace",
        device14: "EQUIPMENTS FOR PLASTIC OF",
        device15: "Extrusion Machine",
        device16: "Extrusion Mould",
        device17: "Inject Mould",
        device18: "Screw and Barrel",
        device19: "PROCESSING EQUIPMENTS FOR STEEL",
        device20: "Multi-Rolling Mill for Steel",
        device21: "Continues casting machine for Steel Billet",
        device22: "EQUIPMENTS AND SOLUTIONS"
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/device/device.vue